export class CacheController {
    private data: {[key: string]: any} = {};
    public Get(key: string): any {
        return this.data[key];
    }
    public Set(key: string, val: any) {
        this.data[key] = val;
    }
    public Clear() {
        this.data = {};
    }
}
